export const APROBADA = 'APROBADA';
export const PENDIENTE = 'PENDIENTE';